import { Injectable, InjectionToken, Inject } from '@angular/core';
import { Currency } from '../../domain/public-api';

export enum RateSource {
  IBM = 'IBM',
  MPOWER = 'MPOWER',
  WIPP = 'WIPP',
  CROESUS = 'CROESUS'
}

export const EXCHANGE_RATES_CONFIGURATION = new InjectionToken<ExchangeRates>('fxRates');

export interface ExchangeRate {
  source: RateSource;
  from: Currency;
  to: Currency;
  rate: number;
}

export type ExchangeRates = {
  [source in RateSource]?: Array<ExchangeRate>;
};

@Injectable({
  providedIn: 'root'
})
export class ExchangeRateService {

  constructor(@Inject(EXCHANGE_RATES_CONFIGURATION) private exchangeRates: ExchangeRates) {
  }

  /**
   * @param  fromCurrency the starting point for this transaction
   * @param  toCurrency the end point for this transaction
   * @param  source of rate data ie; IBM, MPOWER (defaults to IBM)
   * @description
   * matches a rate to a given exchange to and from (source is optional)
   */
  getExchangeRate(fromCurrency: Currency, toCurrency: Currency, source: RateSource = RateSource.IBM): number {
    return this.getRate(fromCurrency, toCurrency, this.getSourceRates(source));
  }

  // Return the array of rates for a given source ie IBM, MPOWER
  private getSourceRates(source: RateSource): Array<ExchangeRate> {
    return this.exchangeRates[source];
  }

  // match the rate for this exchange to and from in array of rates
  private getRate(from: Currency, to: Currency, sourceRates: Array<ExchangeRate>): number | undefined {
    let foundRate;

    if (sourceRates !== undefined) {
      foundRate = sourceRates.find((element: ExchangeRate): boolean => element.from === from && element.to === to);
    }

    return foundRate ? foundRate.rate : foundRate ;

  }
}
